import { FC } from "react";

import { Flex, Spinner } from "@chakra-ui/react";

const SuggestionsLoading: FC = () => (
  <Flex justify="center" py="0.5rem">
    <Spinner />
  </Flex>
);
export default SuggestionsLoading;
